var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsSportFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -1 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-sport-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "athletics-team-running",
    fill: "#7F8BDB",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.438,6.29 C17.7914939,5.77242885 16.8478652,5.87672936 16.33,6.523 L15.674,7.342 C15.2732034,7.84604666 14.5943834,8.03630976 13.99,7.814 L6.99,5.27 C5.20788074,4.62796976 3.21448367,5.1671575 1.999,6.62 L0.85,8 C0.473496402,8.40673202 0.351956909,8.98793178 0.533927959,9.51145105 C0.715899008,10.0349703 1.17172212,10.4154835 1.71932818,10.5010025 C2.26693423,10.5865215 2.81707188,10.3631081 3.15,9.92 L4.303,8.54 C4.70889895,8.05593926 5.37375989,7.87664643 5.968,8.091 L7.643,8.7 L5.762,13.974 C5.55795025,14.5866395 4.98472708,14.9999403 4.339,15 L1.5,15 C0.671572875,15 0,15.6715729 0,16.5 C0,17.3284271 0.671572875,18 1.5,18 L4.339,18 C6.06179165,18.0024935 7.63431016,17.0196694 8.387,15.47 L9.511,15.92 C10.2060827,16.1999183 10.5896371,16.9482754 10.411,17.676 L9.546,21.136 C9.34506275,21.9395603 9.83348252,22.7538917 10.637,22.955 C10.7564183,22.9846019 10.8789678,22.9997107 11.002,23 C11.6897917,22.9994659 12.289096,22.5312337 12.456,21.864 L13.32,18.4 C13.8575673,16.2177865 12.7090438,13.9723059 10.625,13.131 L9.418,12.649 L10.462,9.721 L12.962,10.63 C14.7756266,11.289877 16.808091,10.7198054 18.014,9.213 L18.67,8.4 C18.919293,8.08953281 19.0349194,7.69268814 18.9914021,7.29690649 C18.9478849,6.90112484 18.7487951,6.53888405 18.438,6.29 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSportFilled);
export default __webpack_public_path__ + "static/media/icons-sport-filled.25f40ae29593848e4b44168beec2170a.svg";
export { ForwardRef as ReactComponent };